// extracted by mini-css-extract-plugin
export default {"logo":"navbar_logo__Ul0ZE","container":"navbar_container__TrbnU","fas":"navbar_fas__rMs3q","resume":"navbar_resume__vcNTS"};